import * as React from "react";
import { MultiSelect } from "../components/MultiSelect";
import { QuickSearchMultiSelect } from "../components/QuickSearchMultiSelect";
import { StartCampaignRequestApiModel } from "../apiModels/StartCampaignRequestApiModel";
import { MultiSelectOptionApiModel } from "../apiModels/MultiSelectOptionApiModel";
import { ErrorModal } from "./ErrorModal";
import { HttpErrorHelper } from "../helpers/HttpErrorHelper";
import { RioIf, RioForEach, RioInput, RioValidator, RioResources, RioIconButton, RioApiPost, RioApiGet, RioExpandingPanel, RioModal, RioConfirmModal, RioDatePicker, RioDateHelpers, RioLoadingIf, RioLoadingIndicator } from "rio.react.all";
import * as moment from "moment";


interface ICampaignEmailCustomerSelectModalProps {
    campaignId: number;
    currentStartDate: string;
    onClose: () => void;
}

interface ICampaignEmailCustomerSelectModalState {
    sendToCustomerList: Array<MultiSelectOptionApiModel>
    customersWithReserves: Array<MultiSelectOptionApiModel>
    customCustomers: boolean;
    sendClicked: boolean;
    processing: boolean;

    responseError: string;
    scheduledStartDate: string;
}

export class CampaignEmailCustomerSelectModal extends React.Component<ICampaignEmailCustomerSelectModalProps, ICampaignEmailCustomerSelectModalState> {
    constructor(props: Readonly<ICampaignEmailCustomerSelectModalProps>) {
        super(props);

        this.state = {
            sendToCustomerList: [],
            customersWithReserves: [],
            customCustomers: false,
            sendClicked: false,
            processing: false,
            responseError: null,
            scheduledStartDate: !!props.currentStartDate ? props.currentStartDate : moment().toISOString()
        }
    }

    private validator = new RioValidator();
    private scheduledStartDatePicker = React.createRef<RioDatePicker>();

    render() {
        return (
            <RioModal visible={true} onCancel={() => this.handleCancelClicked()} backgroundClickDisabled={true}>
                <RioIf condition={this.state.processing} then={
                    <React.Fragment>
                        <RioLoadingIndicator />
                        <div className="processingMsgWrapper">
                            <span>{RioResources.find("ProcessingMsg").text}</span>
                        </div>
                    </React.Fragment>
                } otherwise={
                    <React.Fragment>
                        <RioExpandingPanel resource={RioResources.find("SendCampaign")} expandedDefault={true} disableToggle={true}>
                            <div className="no-padding">
                                <div className="form-row scheduledStartDateBox">
                                    <label className="scheduledStartDateLabel">{RioResources.find("ScheduledStartDate").text}</label>
                                    <RioDatePicker
                                        ref={this.scheduledStartDatePicker}
                                        name="scheduledStartDateInput"
                                        validator={null}
                                        from={this.state.scheduledStartDate}
                                        minDate={moment().toISOString()}
                                        onChange={(from: string, to: string) => { this.setState({ scheduledStartDate: from }) }}
                                        asUtc={true}
                                        nullable={true}
                                        time={false}
                                        range={false}
                                        dateFormat={"DD/MM/YYYY"} />
                                </div>
                            </div>
                            <div className="customerSendChoiceRadioItemWrapper">
                                <div className="customerSendChoiceRadioItem">
                                    <RioInput type="radio" className="customerSendChoiceRadioButton" name="customerSendChoice" value="all" onChange={(e) => this.handleRadioChanged(e)} checked={!this.state.customCustomers} />
                                    <span>{RioResources.find("AllCustomers").text}</span>
                                </div>
                                <div className="customerSendChoiceRadioItem">
                                    <RioInput type="radio" className="customerSendChoiceRadioButton" name="customerSendChoice" value="select" onChange={(e) => this.handleRadioChanged(e)} />
                                    <span>{RioResources.find("SelectCustomers").text}</span>
                                </div>
                            </div>

                            <div className={"col-12 col-s-12 no-padding" + (!this.state.customCustomers ? " hidden" : "")}>
                                <div className="form-row">
                                    <QuickSearchMultiSelect potentialOptions={this.state.customersWithReserves} minCharactersBeforeSearch={3} className="emailCustomerSelect" clearInputAfterSelection={false} onChange={(values) => this.setState({ sendToCustomerList: values })} />
                                </div>

                            </div>
                        </RioExpandingPanel>

                        <div className="buttons emailComposerButtons">
                            <RioIconButton resource={RioResources.find("Send")} onClick={() => this.handleSendClicked()} hasPermission={true} />
                            <RioIconButton resource={RioResources.find("Cancel")} onClick={() => this.handleCancelClicked()} hasPermission={true} />
                        </div>

                        <RioIf condition={!!this.state.responseError} then={
                            <ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
                        } />

                        <RioIf condition={!!this.state.sendClicked} then={
                            <RioConfirmModal text={RioResources.find("SendCampaignConfirmMessage")} onConfirmModalClosed={(result) => this.handleConfirmSend(result)} className="confirmModal" />
                        } />
                    </React.Fragment>
                } />

            </RioModal>
        );
    }

    componentDidMount(): void {
        this.getCustomersWithReserves();
    }

    handleCancelClicked() {
        this.props.onClose();
    }

    handleRadioChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.currentTarget.value == "select") {
            this.setState({
                customCustomers: true
            });
        } else {
            this.setState({
                customCustomers: false
            });
        }
    }

    handleSendClicked() {
        this.setState({
            sendClicked: true
        })
    }


    handleConfirmSend(result: boolean) {
        if (result) {
            
            var startCampaignRequest = new StartCampaignRequestApiModel();
            startCampaignRequest.scheduledStartDate = this.state.scheduledStartDate;
            startCampaignRequest.campaignID = this.props.campaignId;
            var customerList = new Array<string>();
            if (this.state.customCustomers) {
                this.state.sendToCustomerList.forEach(customer => {
                    customerList.push(customer.value);
                });
                startCampaignRequest.customerList = customerList;
            } else {
                startCampaignRequest.sendToAll = true;
            }
            RioApiPost.asPromise("/api/CampaignEmail/StartCampaign", startCampaignRequest)
                .then(() => {
                    if (!!Response) {
                        this.setState({
                            sendClicked: false,
                            processing: false
                        });
                        this.props.onClose();
                    }

                })
                .catch((response) => {
                    var error = HttpErrorHelper.handleHttpError(response, this, this.validator); //handles validator errors if validator passed
                    this.setState({ responseError: error, processing: false, sendClicked: false });
                });
            this.setState({
                processing: true
            });
        } else {
            this.setState({
                sendClicked: false
            });
        }
    }

    getCustomersWithReserves() {
        RioApiGet.asPromise<Array<CustomerApiModel>>("/api/Customer/GetCustomersWithReserves")
            .then(response => {
                let results: Array<MultiSelectOptionApiModel> = [];
                response.forEach(customer => {
                    let result = new MultiSelectOptionApiModel();
                    result.value = customer.accountNo;
                    result.text = customer.accountNo + " - " + customer.name;
                    if (customer.optOutEmail) {
                        result.text += RioResources.find("CustomerSelectOiptOutSuffix").text;
                    }
                    result.disabled = customer.optOutEmail;
                    results.push(result);
                });
                this.setState({
                    customersWithReserves: results
                });
            })
            .catch((response) => {
                var error = HttpErrorHelper.handleHttpError(response, this, this.validator); //handles validator errors if validator passed
                this.setState({ responseError: error });
            });
    }

}